import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	areWidgetsVisible: true,
};

const widgetVisibilitySlice = createSlice({
	name: 'widgetVisibility',
	initialState,
	reducers: {
		toggleWidgetsVisibility: (state) => {
			state.areWidgetsVisible = !state.areWidgetsVisible;
		},
	},
});

export const { toggleWidgetsVisibility } = widgetVisibilitySlice.actions;
export default widgetVisibilitySlice.reducer;
